import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HttpClient} from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { HttpService } from "./http-service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NewsletterService extends HttpService {
  constructor(
    http: HttpClient,
    router: Router,
    toastService: ToastrService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    super(http, router, toastService, platformId);
  }
  

  public post(nome: string, email: string, callback) {
    super.post("newsletter", { email: email, nome: nome }, callback);
  }
}
